export default __webpack_public_path__ + "static/media/048.9922d6ab.jpg";